import React from 'react';
import { isMobile } from '../../../../utils/helper/page-behavior-helper';
import Button from '../../../../components/UI/button/button';
import './index.scss';

export default function SliderItem({
  title,
  description,
  alternativeDescription,
  buttonText,
  onClickButton,
  image,
  altImagem,
  customMarginBottom,
  imageWidth,
  buttonId
}) {
  return (
    <div className="slider-item-container">
      <div>
        <p>
          {title}
        </p>

        <p>
          {description}
        </p>

        {alternativeDescription && (
          <p>
            {alternativeDescription}
          </p>
        )}

        {buttonText && (
          <Button id={buttonId} rounded onClick={onClickButton} width={isMobile() ? 'auto' : null} margin={isMobile() ? "12px 0" : "30px 0"}>
            {buttonText}
          </Button>
        )}
      </div>

      <div style={{ bottom: customMarginBottom }}>
        <img src={image} alt={altImagem} style={{ width: imageWidth }} />
      </div>
    </div>
  )
}
